import { FetchResult, MaybeMasked } from '@apollo/client'
import { client } from '../../..'
import {
  ManagerForceMeetingConfirmationMutation,
  ManagerForceMeetingConfirmationMutationVariables,
  Country,
  RoleName,
} from '../../../types'
import { EMPLOYEES_AND_APPRAISALS } from '../../employee/Queries'
import { EMPLOYEE_DISPLAY_SHORT_INFO_BY_REVIEWER_OR_BUSINESS_UNIT_MANAGER_OR_COMPANY_MANAGER } from '../../employee/hooks/useEmployeeDisplayShortInfoByReviewerOrBusinessUnitManagerOrCompanyManager'
import { COMPANY_MANAGER_DASHBOARD_APPRAISAL_MEETING_STATUS } from '../../company-manager-dashboard/appraisal-meeting-status/Queries'
import { ForceConfirmationRefetchContext } from '../../../modules/meeting/ForceConfirmationModal'
import { MANAGER_FORCE_MEETING_CONFIRMATION } from '../MeetingMutations'
import { MEETINGS_BY_MANAGER, SUBORDINATE_MEETINGS } from '../meeting.graphql'

function refetchQueriesForForceConfirmation(
  refetchContext: ForceConfirmationRefetchContext,
  companyId: string,
  country: Country,
  userId: string,
  userDashboardRoles?: RoleName[],
) {
  switch (refetchContext) {
    case ForceConfirmationRefetchContext.MeetingsLists:
      return [
        {
          query: SUBORDINATE_MEETINGS,
          variables: {
            managerId: userId,
          },
        },
        {
          query: MEETINGS_BY_MANAGER,
          variables: {
            managerId: userId,
            disputedMeetingsIncluded: false,
          },
        },
        {
          query: EMPLOYEE_DISPLAY_SHORT_INFO_BY_REVIEWER_OR_BUSINESS_UNIT_MANAGER_OR_COMPANY_MANAGER,
        },
      ]
    case ForceConfirmationRefetchContext.CompanyAppraisalSettings:
      return [
        {
          query: EMPLOYEES_AND_APPRAISALS,
          variables: {
            companyId,
            country,
          },
        },
      ]
    case ForceConfirmationRefetchContext.CompanyManagerDashboardMonitoring: {
      return [
        {
          query: COMPANY_MANAGER_DASHBOARD_APPRAISAL_MEETING_STATUS,
          variables: {
            companyId,
            userDashboardRoles: userDashboardRoles!,
          },
        },
      ]
    }
    default: {
      const _never: never = refetchContext
      return _never
    }
  }
}

export const managerForceMeetingConfirmation = async (
  companyId: string,
  country: Country,
  meetingId: string,
  reason: string,
  userId: string,
  refetchContext: ForceConfirmationRefetchContext,
  userDashboardRoles?: RoleName[],
): Promise<FetchResult<MaybeMasked<ManagerForceMeetingConfirmationMutation>>> => {
  return await client.mutate<ManagerForceMeetingConfirmationMutation, ManagerForceMeetingConfirmationMutationVariables>({
    mutation: MANAGER_FORCE_MEETING_CONFIRMATION,
    variables: {
      meetingId,
      reason,
    },
    update: (_store, { data }) => {
      if (!data || !data.managerForceMeetingConfirmation) {
        throw new Error('Invalid force meeting confirmation mutation')
      }
    },
    refetchQueries: refetchQueriesForForceConfirmation(refetchContext, companyId, country, userId, userDashboardRoles),
  })
}
